module.exports = __webpack_public_path__ + "static/media/check.4fd81cf9.svg";